import React, { Component } from 'react';

import CamdetectCamerasModel from './CamdetectCamerasModel';

import { Select } from 'antd';
const Option = Select.Option;

class CamdetectCameraSelect extends Component {

    state = {
        children: []
    }

    componentWillMount() {
        CamdetectCamerasModel.getAll()
            .then(data => {
                var children = [];
                data.map((child, key) => {
                    return children.push(<Option key={child.id}>{child.cameraName}</Option>);
                });
                this.setState({
                    children: children
                });
            });
    }

    render() {
        return (
            <Select
                size="default"
                showSearch
                placeholder={this.props.placeholder ? this.props.placeholder : 'Zvolte kameru'}
                optionFilterProp="children"
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                onChange={(value) => { this.props.onChange(value) }}
                {...this.props}>
                {this.state.children}
            </Select>
        );
    }
}

export default CamdetectCameraSelect;


// WEBPACK FOOTER //
// ./src/components/CamdetectCamerasSelect.js